import lazyLoading from "./lazyLoading";

export default {
  name: "assays",
  path: "/assays",
  component: lazyLoading("assays/Assays"),
  meta: {
    default: false,
    title: "Assays",
    class: "info",
    show: true,
    iconClass: "fa fa-font",
    requiredAuth: true
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/menu/assays.js